if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        window.pauseAllMedia();
        
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
          const deferredMedia = element.querySelector('deferred-media, product-model');
          if (deferredMedia) {
            const video = deferredMedia.querySelector('video');
            if (video && !video.paused) {
              video.pause();
            }
            const modelViewer = deferredMedia.querySelector('model-viewer');
            if (modelViewer && modelViewer.pause) {
              modelViewer.pause();
            }
          }
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        const centerOffset = (activeMedia.width - container.clientWidth) / 2;
        // scrollLeft runs negative in RTL (Chrome/Firefox convention) -- flip
        // the sign so this still centers the media instead of scrolling the
        // wrong way; the centering math itself is direction-neutral.
        container.scrollLeft = document.documentElement.getAttribute('dir') === 'rtl' ? -centerOffset : centerOffset;

        const deferredMedia = activeMedia.querySelector('deferred-media, product-model');
        if (deferredMedia && (deferredMedia.nodeName === 'DEFERRED-MEDIA' || deferredMedia.nodeName === 'PRODUCT-MODEL')) {
          deferredMedia.loadContent();
        }
      }
    }
  );
}
